import React from "react";
import "./LinearChart.css";

function LinearChart({
  value = 73,
  label = "Quiet",
  subLabel = "",
  description = "",
  gradientColors = ["#7c3fc4", "#c9a8f0"],
  trackColor = "#7c3fc4",
  iconimage
}) {
  const [darkColor, lightColor] = gradientColors;

  return (
    <div className="lc-wrapper">
      {/* Top row: label left, percentage right */}
      <div className="lc-top-row">
        <span className="lc-label">{label}</span>
        <span className="lc-percent">{value}%</span>
      </div>

      {/* Bar container */}
      <div className="lc-track-outer">
        {/* Background track - full width, light purple, border radius on right */}
        <div
          className="lc-track"
          style={{ backgroundColor: trackColor }}
        />

        {/* Progress fill - dark purple gradient, border radius on right only */}
        <div
          className="lc-fill"
          style={{
            width: `${value}%`,
            background: `linear-gradient(to right, ${darkColor}, ${lightColor})`,
          }}
        />

        {/* Sub-label inside bar */}
        <span className="lc-inner-label">
            <>
              <img src={iconimage} alt={subLabel} />
              {subLabel}
            </>
        </span>
      </div>

      {/* Description below */}
      <p className="lc-description" dangerouslySetInnerHTML={{ __html:description }}  />

      {/* <span className="lc-hide-description" dangerouslySetInnerHTML={{ __html:description }}  /> */}

    </div>
  );
}

export default LinearChart;
